import Marionette from 'backbone.marionette';
import ItemCompositview from './bill_search_item_compositview';
import billSearchLayoutTmpl from '../templates/bills_search_layout.tpl';
export default Marionette.CompositeView.extend({
  childView: ItemCompositview,
  childViewContainer: '#search-results-region',
  template: billSearchLayoutTmpl
});